// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selector_wrapper__2w0tv","headingWrapper":"selector_headingWrapper__3MtM6","headingSection":"selector_headingSection__3rL-9","arrow":"selector_arrow__3IoqY"};